export const lightenDarkenColor = (col: string, amt: number): string => {
    let usePound = false;
    if (col[0] === "#") {
        col = col.slice(1);
        usePound = true;
    }

    const num = parseInt(col, 16);
    let r = (num >> 16) + amt;
    let g = ((num >> 8) & 0x00FF) + amt;
    let b = (num & 0x0000FF) + amt;

    r = r > 255 ? 255 : r < 0 ? 0 : r;
    g = g > 255 ? 255 : g < 0 ? 0 : g;
    b = b > 255 ? 255 : b < 0 ? 0 : b;

    return (usePound ? "#" : "") + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

// Convert rgba color array to CSS rgba string
export const rgba = ([r, g, b, a]: number[]) => `rgba(${r}, ${g}, ${b}, ${a / 255})`;

// Converts rgba color array to hex and opacity
export const rgbaToHexAndOpacity = ([r, g, b, a = 255]: number[]) => {
  const hex = '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
  const opacity = Math.round((a / 255) * 1000) / 1000; // round to 3 decimals
  return { hex, opacity };
};
